import { useState } from 'react';
import { communityComments } from '@/mocks/nav';

export default function Community() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [visible, setVisible] = useState(3);

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const shown = communityComments.slice(0, visible);

  return (
    <section id="community" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.28em] text-accent-600">COMMUNITY</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              打不开的时候
              <br />
              大家都在这里报路况
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              哪条线路快、哪个地区刚恢复，用户会第一时间在下面留言。你的反馈也会同步给我们，用于补充最新地址。
            </p>

            <div className="mt-8 rounded-lg bg-background-100 border border-background-200/70 p-6">
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 font-heading text-lg">
                  我
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-foreground-950">说说你的访问情况</p>
                  <p className="font-label text-xs text-foreground-500">留言仅作展示，不会真实提交</p>
                </div>
              </div>
              <textarea
                value={draft}
                onChange={(e) => setDraft(e.target.value.slice(0, 500))}
                maxLength={500}
                rows={3}
                placeholder="例如：江苏移动，主入口正常，备用线路 B 更快"
                className="mt-4 w-full resize-none rounded-md border border-background-300/70 bg-background-50 px-3.5 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400"
              />
              <div className="mt-3 flex items-center justify-between">
                <span className="font-label text-xs text-foreground-400">{draft.length}/500</span>
                <button
                  type="button"
                  onClick={() => setDraft('')}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  发布留言
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-4">
              {shown.map((c) => {
                const isLiked = liked[c.id];
                return (
                  <article
                    key={c.id}
                    className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
                  >
                    <div className="flex items-start gap-4">
                      <span className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 font-heading text-lg">
                        {c.user.slice(0, 1)}
                      </span>
                      <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                          <span className="font-heading text-sm font-bold text-foreground-950">{c.user}</span>
                          <span className="font-label text-xs text-foreground-500">{c.location}</span>
                          <span className="font-label text-xs text-foreground-400">· {c.time}</span>
                          {c.resolved && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-label">
                              <i className="ri-check-double-line"></i>
                              已解决
                            </span>
                          )}
                        </div>
                        <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                        <div className="mt-3.5 flex items-center gap-5">
                          <button
                            type="button"
                            onClick={() => toggleLike(c.id)}
                            className={`inline-flex items-center gap-1.5 text-xs font-label transition-colors cursor-pointer ${
                              isLiked ? 'text-accent-600' : 'text-foreground-500 hover:text-accent-600'
                            }`}
                          >
                            <i className={isLiked ? 'ri-heart-3-fill' : 'ri-heart-3-line'}></i>
                            {c.likes + (isLiked ? 1 : 0)}
                          </button>
                          <button
                            type="button"
                            className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                          >
                            <i className="ri-chat-1-line"></i>
                            {c.replies} 条回复
                          </button>
                          <button
                            type="button"
                            className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                          >
                            <i className="ri-share-forward-line"></i>
                            分享
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>

            {visible < communityComments.length ? (
              <button
                type="button"
                onClick={() => setVisible(communityComments.length)}
                className="mt-5 w-full py-3.5 rounded-md border border-background-300/70 text-sm font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                查看更多留言
              </button>
            ) : (
              <p className="mt-5 text-center text-xs font-label text-foreground-400">已经到底啦</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}